export const UI_VALUE_LOADING_CHECKOUT_ADDRESS = 'loadingCheckoutAddress';
export const UI_VALUE_LOADING_FULFILLMENT = 'loadingFulfillment';

export const UI_VALUE_SHOW_SHOPPING_CART = 'showShoppingCart';

export const UI_VALUE_SHOW_POPUP_HOME = 'showPopupHome';

export const UI_VALUE_SUBSCRIBE_PRODUCT_ID = 'showModalSubscribeStockProduct'
